<template>
  <div class="formEditUser">
      <v-form
          ref="form"
          v-model="valid"
        >
      <DadosPessoaisForm v-bind="mountObjectDadosPessoais" v-on:update="update" />
      <EnderecoForm v-bind="mountObjectEndereco"/>
      <DadosCadastroForm :email="email" :socialId="facebookID || googleID" birthday/>
      <MinhaCarteira @retrieveMyUser='() => emitToParent("retrieveMyUser",this)' :paymentCards="paymentCards" :userId="id" />
      <MeuCartaoGiro @retrieveMyUser='() => emitToParent("retrieveMyUser",this)' :giroCards="cards" :activeGiroCard="activeCard" :userId="id"/>
      <p v-if='msgCardBlocked' style='color: red; font-size:12px;'>{{msgCardBlocked}}</p>
      </v-form>
      
      <div class="div-checkbox">
        <input type="checkbox" v-model="infoPromo" name="infoPromo" />
        <div class="styled-checkbox" @click="infoPromo = !infoPromo"><Check v-if="infoPromo"/></div>
        <span>Quero ser informado de promoções e novidades do MetrôRio por e-mail</span>
      </div>
    <!-- <span v-if="!valid" class="formError" style="display:none;">Verifique os Campos do Formulário</span> -->
    <a @click="submit() "  appEvent="true" appEventCategory="meus-dados" appEventLabel="salvar" class="btn block">continuar</a>
  </div>
  
</template>

<script>

import {VForm} from 'vuetify/lib'
import DadosPessoaisForm from '@/components/DadosPessoaisForm.vue'
import EnderecoForm from '@/components/EnderecoForm.vue'
import DadosCadastroForm from '@/components/DadosCadastroForm.vue'
import MinhaCarteira from '@/components/MinhaCarteira.vue'
import MeuCartaoGiro from '@/components/MeuCartaoGiro.vue'
import Check from '@/components/svg/Check.vue'
import {isUnderYearsOld,resolvePromise,emitToParent,returnPopupObject,formatDateToSend,popupMessages} from '../helpers/helpers'
import {updateMyUser} from '../services/user.service'
import {save} from '../services/girocard.service'

export default {
  name: 'FormEditUser',
  data(){
    return{
      dialog:false,
      message:null,
      cardMessage:null,
      valid:false,
      aniversario: false,
      msgCardBlocked: null,
    }
  },
  props:{
    name:{
      type:String
    },
    lastName:{
      type:String
    },
    cpf:{
      type:String
    },
    birthday:{
      type:String
    },
    phone:{
      type:String
    },
    cep:{
      type:String
    },
    uf:{
      type:String
    },
    city:{
      type:String
    },
    address:{
      type:String
    },
    addressNumber:{
      type:String
    },
    addressComplement:{
      type:String
    },
    email:{
      type:String
    },
    cards:{
      type:Array
    },
    activeCard:{
      type:Object
    },
    id:{
      type:Number
    },
    paymentCards:{
      type:Array
    },
    infoPromo:{
      type:Boolean
    },
    googleID:{
      type:String
    },
    facebookID:{
      type:String
    },
    authResponsible:{
      type:Boolean
    }

  },
  mounted() {
    setTimeout(() => {
      this.aniversario = this.birthday.split('T')[0].split('-').reverse().join('/');
      console.log('ready', this.birthday, this.aniversario);
    }, 500);
  },
  methods:{
    update(data){
      this.aniversario = data.birthday;
    },
    emitToParent,
    returnPopupObject,
    setFormData:formData => ({value,name,type,checked}) =>{
      if(name === "BirthDay" && !value) return
      if(name === "BirthDay") value = formatDateToSend(value)
      if(type === "hidden") name = "uf"
      formData.set(name,value === "on" ? checked : value)
    },
    editSucess({data}){
      this.emitToParent("userData",this,data); 
      this.emitToParent("openPopup",this,this.returnPopupObject("ok","sEdit"))
    },
    editError(err){
      this.emitToParent("openPopup",this,this.returnPopupObject("err",err))
    },
    submit(){
      let authResponsible = document.querySelector('[name="AuthResponsible"]') && document.querySelector('[name="AuthResponsible"]').checked;
      if(this.betWeen12and18 && !authResponsible) {
        return;
      }
      const 
        user = new FormData(),
        arrayGiro =  Array.from(document.querySelectorAll('.meuCartaoGiro input')).map(({value})=> value).filter(v=>v)
      this.msgCardBlocked = null;
      this.message = "Erro na chamada"
      Array.from(document.querySelectorAll('.formEditUser input')).forEach(this.setFormData(user))
      for (var value of user.keys()) console.log(value, user.get(value));

      if(this.$refs.form.validate()){
        resolvePromise(updateMyUser(user),(data) => {
          if((new Set(arrayGiro)).size !== arrayGiro.length){
            const card = new FormData()
            card.append("CardNumber",arrayGiro[0])
            card.append("Active", true)
            resolvePromise(save(card),()=> {
              this.editSucess(data);
              this.cardMessage = "Cartão adicionado com sucesso";
            },(err)=> {
              this.cardMessage = "Erro ao adicionar cartão";
              if(err == 'CARD-BLACK-LIST') {
                this.msgCardBlocked = popupMessages.cardBlock.validation;
              }
            },this)
          } else {
            this.editSucess(data);
          }
        }, this.editError, this);
      }

      else document.querySelector('.formError').style.display = "block"
    },
  },
  computed:{
    betWeen12and18: function() {
      let x = isUnderYearsOld(this.aniversario, 18) && !isUnderYearsOld(this.aniversario, 16);
      return x;
    },
    mountObjectDadosPessoais(){
      return {
        name:this.name,
        lastName:this.lastName,
        cpf:this.cpf,
        birthday:this.birthday,
        phone:this.phone,
        authResponsible: this.authResponsible
      }
    },
    mountObjectEndereco(){
        return {
        cep:this.cep,
        uf:this.uf,
        city:this.city,
        addressComplement:this.addressComplement,
        address:this.address,
        addressNumber:this.addressNumber
      }
    }
  },
  components: {
     DadosPessoaisForm,
    EnderecoForm,
    DadosCadastroForm,
    MinhaCarteira,
    MeuCartaoGiro,
    Check,
    VForm
    }

  }
</script>

<style scoped lang="scss">
  @import "../assets/scss/formEditUser.scss";
</style>
